import api from '../api';

import { ParamsCustomerCharges, ParamsPaymentFormsInitial, ParamsBank } from 'utils/typeServices';

type ParamsResponse = {
    Data: {
        Faturas: Array<ParamsCustomerCharges>;
        FormaPagmento: Array<ParamsPaymentFormsInitial>;
        PagamentosDebitoEmConta: Array<ParamsBank>;
    };
}

export const GetCustomerCharges = async ({ token, nrPlatform }: { token: string, nrPlatform: number }) => {
    try {
        const { data } = await api.get<ParamsResponse>(`/v1/Pagamento/GetBillingsByCustomerPlataformApp/${nrPlatform}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
